import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/Icons/delete.svg";

const DeleteIcon = (props) => {
  return (
    <Wrapper onClick={props.onClick} disabled={props.disabled} size={props.size}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default DeleteIcon;
